import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";

export default function RisikohinweisPage() {
    return (
        <LegalPage title="Risikohinweis">
            <p>
                Der Handel mit Aktien und anderen Finanzinstrumenten ist mit erheblichen
                Risiken verbunden.
            </p>

            <h2>Wesentliche Risiken</h2>
            <ul>
                <li>erhebliche Kursschwankungen</li>
                <li>teilweiser oder vollständiger Kapitalverlust</li>
                <li>unvorhersehbare Marktreaktionen auf Nachrichten</li>
                <li>fehlerhafte oder verspätete KI-Signale</li>
                <li>
                    abweichende tatsächliche Kursreaktionen trotz positiver oder negativer
                    Nachrichtenlage
                </li>
            </ul>

            <p>
                Bitte treffen Sie Anlageentscheidungen nur auf Grundlage Ihrer eigenen
                Prüfung und Ihrer individuellen finanziellen Situation.
            </p>
        </LegalPage>
    );
}